import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom';
import { formatDbDateWithoutTime } from '../../../utils/dateFormater';
import { blockAdminAction, UpdateStatusAction } from '../../../redux/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../loader/loader';
import DefaultAvatar from "../../images/default_avatar.jpg"
import { toast } from 'react-toastify';
import HoverFullText from "../../../elements/HoverToolKit";
const SingleAdmin = ({ admin, index, length }) => {




    const [copied, setCopied] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState("");
    const [popupHeading, setPopupHeading] = useState("");
    const [popupPara, setPopupPara] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const [showSecondPopup, setShowSecondPopup] = useState(false);
    const [reassignedAdminID, setReassignedAdminID] = useState("");
    const [blockUser, setBlockUser] = useState(null);



    const { error } = useSelector(state => state.inviteUser)


    const dispatch = useDispatch()

    const { loading } = useSelector(state => state.inviteUser)
    const { admins, } = useSelector((state) => state.getUsers)



    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const displayIndex = String(length - index).padStart(2, '0');



    const handleUpdateStatus = (userId, UserStatus) => {



        if (!UserStatus) return


        if (actionToPerform === "BLOCKED") {
            setBlockUser(1)
            setShowSecondPopup(true)
            setShowPopup(false)
            setActionToPerform("")
            setPopupHeading("")
            setPopupPara("")
            return
        }


        let userData = {
            id: userId,
            status: UserStatus === "DIRECT_BLOCKED" ? "BLOCKED" : UserStatus
        }

        dispatch(UpdateStatusAction(userData));

    }




    const handleReject = () => {



        setShowPopup(false)
        setActionToPerform("")
        setPopupHeading("")
        setPopupPara("")

    }

    const handleBlock = () => {


        if (!reassignedAdminID) return toast.error('Please Select Admin')

        dispatch(blockAdminAction({
            admin_id: admin?.id,
            next_admin_id: reassignedAdminID,
            blockUser
        }))


    }



    useEffect(() => {

        if (error) {
            setShowPopup(false)
            setActionToPerform("")
            setPopupHeading("")
            setPopupPara("")
        }

    }, [error])


    return (
        <Fragment>
            {loading && <Loader />}
            <div className="flex flex-col min-w-[1400px] border border-zinc-100 border-l-4 border-l-indigo-600 bg-white rounded-r-xl rounded-l-md hover:shadow-md transition-all mb-[1vmax] relative" >
                
                {/* Top Section: Details */}
                <div className="flex py-[1.2vmax] items-center">
                    <div className="text-center flex-[0.5] text-zinc-400 font-jakarta font-bold text-[0.9vmax]" >
                        {displayIndex}
                    </div>
                    <div className="px-[1vmax] flex-[1] flex gap-[0.5vmax] items-center" >
                        <div className="w-[2vmax] h-[2vmax]" >
                            <img src={admin?.avatar_url || DefaultAvatar} alt="" className="w-full h-full rounded-full border border-zinc-100" />
                        </div>
                        <span className="text-zinc-800 font-jakarta font-bold text-[0.85vmax]" >{admin?.name}</span>
                    </div>
                    <div className="px-[1vmax] flex-[1.5] flex items-center" >
                        <span className="text-zinc-500 font-jakarta text-[0.8vmax] lowercase" >{admin?.email}</span>
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[0.5] text-gray-700 font-bold text-[0.9vmax]" >
                        {admin.pmm_count || 0}
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[0.5] text-gray-700 font-bold text-[0.9vmax]" >
                        {admin.pm_count || 0}
                    </div>

                    <div className="flex-center px-[0.5vmax] flex-[1.2] text-gray-700 font-bold text-[0.9vmax] gap-1" >
                        {admin.id || "000"}
                        <button
                            onClick={() => handleCopy(admin.id)}
                            className="text-gray-400 hover:text-indigo-600 transition-colors"
                            title={copied ? "Copied" : "Copy"}
                        >
                            <i className={`fa-regular ${copied ? "fa-circle-check text-emerald-500" : "fa-copy"}`}></i>
                        </button>
                    </div>

                    <div className="flex flex-col items-center justify-center text-center px-[0.5vmax] flex-[1.5] text-gray-700 text-[0.9vmax]" >
                        <span className="font-bold text-gray-800">
                            <HoverFullText text={admin.referal_name || "N/A"} sliceLength={20} />
                        </span>
                        {admin.refered_by && (
                            <span className="text-gray-400 text-[0.8vmax]">ID: {admin.refered_by}</span>
                        )}
                    </div>

                    <div className="text-center px-[0.5vmax] flex-[1] text-gray-500 text-[0.85vmax]" >
                        {formatDbDateWithoutTime(admin.created_at)}
                    </div>

                    <div className="flex justify-center flex-[1] items-center relative" ref={dropdownRef}>
                        <button 
                            onClick={() => setShowDropdown(!showDropdown)}
                            className={`px-[1vmax] py-[0.4vmax] rounded-lg text-[0.75vmax] font-bold transition-colors text-white flex items-center gap-1 
                                ${admin.status === "ACTIVE" ? "bg-emerald-600 hover:bg-emerald-700" :
                                  admin.status === "BLOCKED" ? "bg-rose-600 hover:bg-rose-700" : 
                                  "bg-amber-600 hover:bg-amber-700"}`}
                        >
                            {admin.status === "ACTIVE" ? "Active" :
                             admin.status === "BLOCKED" ? "Blocked" : "Suspended"}
                            <i className="fa-solid fa-chevron-down text-xs"></i>
                        </button>
                        
                        {showDropdown && (
                            <div className="absolute right-0 top-full mt-1 w-[170px] bg-white border border-gray-100 shadow-lg rounded-lg z-[10] overflow-hidden">
                                <Link 
                                    to={`/dashboard/user-details?user_id=${admin.id}`} 
                                    className="flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium"
                                    onClick={() => setShowDropdown(false)}
                                >
                                    <i className="fa-regular fa-eye mr-2 w-4"></i> View Details
                                </Link>
                                
                                <button 
                                    className={`flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium ${admin.status === "BLOCKED" ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={admin.status === "BLOCKED"}
                                    onClick={() => {
                                        setShowDropdown(false)
                                        setShowPopup(true)
                                        setActionToPerform(
                                            (admin?.pm_count || 0) + (admin?.pmm_count || 0) === 0 ? "DIRECT_BLOCKED" : "BLOCKED"
                                        )
                                        setPopupHeading(`Block ${admin.name}`)
                                        setPopupPara(
                                            (admin?.pm_count || 0) + (admin?.pmm_count || 0) === 0 ?
                                                `Are you sure you want to permanently block ${admin?.name}` :
                                                `This admin currently manages ${admin.pmm_count + admin.pm_count} user(s). Blocking them could disrupt those user(s)' access and operations. Do you want to reassign their users to another admin before continuing?`
                                        )
                                    }}
                                >
                                    <i className="fa-solid fa-user-slash mr-2 w-4"></i> Block Permanently
                                </button>
                                
                                {(admin?.pm_count || 0) + (admin?.pmm_count || 0) > 0 &&
                                    <button 
                                        className={`flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium ${admin.status === "BLOCKED" ? "opacity-50 cursor-not-allowed" : ""}`}
                                        disabled={admin.status === "BLOCKED"}
                                        onClick={() => {
                                            setShowDropdown(false)
                                            setShowSecondPopup(true)
                                            setBlockUser(0)
                                        }}
                                    >
                                        <i className="fa-solid fa-arrow-right-arrow-left mr-2 w-4"></i> Transfer Users
                                    </button>
                                }
                                
                                <button 
                                    className={`flex items-center w-full text-left px-4 py-2 text-[0.75vmax] text-gray-700 hover:bg-gray-50 font-medium ${admin.status === "BLOCKED" ? "opacity-50 cursor-not-allowed" : ""}`}
                                    disabled={admin.status === "BLOCKED"}
                                    onClick={() => {
                                        setShowDropdown(false)
                                        setShowPopup(true)
                                        setActionToPerform(admin.status === "TEMPORARILY_BLOCKED" ? "ACTIVE" : "TEMPORARILY_BLOCKED")
                                        setPopupHeading(`${admin.status === "TEMPORARILY_BLOCKED" ? "Mark Active" : " Temporarily Block"} ${admin.name}`)
                                        setPopupPara(`Are you sure want to ${admin.status === "TEMPORARILY_BLOCKED" ? "Active" : "Temporarily Block"} ${admin.name}`)
                                    }}
                                >
                                    <i className="fa-solid fa-user-clock mr-2 w-4"></i> {admin.status === "TEMPORARILY_BLOCKED" ? "Mark Active" : "Block Temporarily"}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showPopup &&
                <section className="flex justify-center w-[100vw] h-[100vh] fixed top-0 left-0 
            bg-[#0000006c] z-[9999999999]">
                    <button className="text-[4vmax] lg:text-[2.5vmax] text-white fixed top-[2vmax] right-[2vmax]"
                        onClick={() => {
                            setShowPopup(false)
                            setActionToPerform("")
                            setPopupHeading("")
                            setPopupPara("")
                        }}
                    >
                        <div className="fa-solid fa-xmark"></div>
                    </button>
                    <div className="bg-white shadow-lg   rounded-[2vmax] h-fit mt-[2vmax] overflow-hidden">
                        <h2 className="text-[2vmax] lg:text-[1.4vmax] font-3 font-[900] text-white p-[0.5vmax_3vmax] bg-[var(--secondary)] mb-[1vmax] text-center" >{popupHeading}</h2>
                        <p className='max-w-[33vmax] p-[0vmax_2vmax_2vmax_2vmax] text-gray-600 font-[600] font-3' >
                            {popupPara}
                        </p>
                        <div className="flex justify-end gap-[1vmax] p-[2vmax] pt-0">
                            <button className="text-[1.4vmax] lg:text-[0.9vmax] text-white bg-[image:var(--gradient-5)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => handleReject()}
                            >
                                {actionToPerform === "BLOCKED" ? "Cancel" : "No"}

                            </button>
                            <button className="text-[1.4vmax] lg:text-[0.9vmax] text-white bg-[image:var(--gradient-3)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => handleUpdateStatus(admin?.id, actionToPerform)}
                            >
                                {actionToPerform === "BLOCKED" ? "Reassign Users" : "Yes"}
                            </button>
                        </div>
                    </div>
                </section>
            }
            {showSecondPopup &&
                <section className="flex justify-center w-[100vw] h-[100vh] fixed top-0 left-0 
            bg-[#0000006c] z-[9999999999]">
                    <button className="text-[2.5vmax] text-white fixed top-[2vmax] right-[2vmax]"
                        onClick={() => {
                            setShowSecondPopup(false)
                        }}
                    >
                        <div className="fa-solid fa-xmark"></div>
                    </button>
                    <div className="bg-white shadow-lg   rounded-[2vmax] h-fit mt-[2vmax] overflow-hidden">
                        <h2 className="text-[2vmax] lg:text-[1.4vmax] font-3 font-[900] text-white p-[0.5vmax_3vmax] bg-[var(--secondary)] mb-[1vmax] text-center" >Reassigning {admin?.name} Users. </h2>
                        <select name="" id="" className='w-[30vmax] lg:w-[25vmax] m-[2vmax] mt-[1vmax] p-[0.5vmax_1vmax] bg-slate-50  border-2 border-slate-200 rounded-lg text-[1.4vmax] lg:text-[1vmax] '
                            value={reassignedAdminID}
                            onChange={(e) => setReassignedAdminID(e.target.value)}
                        >
                            <option value="">--select Admin</option>
                            {admins?.length > 1 ?
                                admins?.filter(prev => prev.id !== admin.id && prev.status === "ACTIVE").map((otherAdmin) => (
                                    <option key={otherAdmin.id} value={otherAdmin.id}>
                                        ID :  {otherAdmin.referral_id || "000000"}
                                        &nbsp;&nbsp;&nbsp;
                                        Name : {otherAdmin.name}
                                    </option>
                                ))
                                :
                                <option value="">No Admin Found Other then {admin.name}</option>

                            }
                        </select>
                        <div className="flex justify-end gap-[1vmax] p-[2vmax] pt-0">
                            <button className="text-[1.4vmax] lg:text-[0.9vmax] text-white bg-[image:var(--gradient-3)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => {
                                    setShowSecondPopup(false)
                                    setReassignedAdminID("")
                                }}
                            >
                                Cancel

                            </button>
                            <button className={`text-[1.4vmax] lg:text-[0.9vmax] text-white bg-[image:var(--gradient-5)] p-[0.5vmax_1vmax] rounded-lg ${reassignedAdminID ? "opacity-100" : "opacity-50"}`}
                                onClick={() => handleBlock(admin?.id, "BLOCKED")}
                                disabled={reassignedAdminID ? false : true}
                            >
                                Proceed
                            </button>
                        </div>
                    </div>
                </section>
            }
        </Fragment>
    )
}

export default SingleAdmin